var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKajabi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1200 282.5"
    },
    xmlSpace: "preserve",
    viewBox: "0.04 0 1199.96 282.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:url(#SVGID_1_);}\t.st1{fill:url(#SVGID_00000016044090666858220420000016412182451971700661_);}\t.st2{fill:url(#SVGID_00000080922342739543106470000001139802013521963711_);}\t.st3{fill:url(#SVGID_00000174588428179830792940000005824601959184846264_);}")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496.9,72.4h-54.4l-59.6,61.1V7.5H339v234.6h43.8v-56.6l14.6-14.6l48.4,71.2h51.4l-70-100.7L496.9,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.1,241.9h-43.8c0,0,0.1-12.3,0.1-16.1c-11.2,12.2-27.3,19.8-51.1,19.8c-50.4,0-84.5-39.2-84.5-88.1l0,0    c0-49.2,34.3-88.1,84.5-88.1c23.7,0,39.8,7.9,51.1,19.1V72.3h43.2L664.1,241.9z M574.5,206.6c24,0,45-18.8,45-49.2    c0-30.4-21-49.2-45-49.2c-25.2,0-45.3,18.5-45.3,49.2C529.3,188.1,549.3,206.6,574.5,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.6,241.6h-43.1c0,0-0.1-12.3-0.1-16.1c-11.2,12.2-27.3,19.8-51.1,19.8c-50.4,0-84.5-39.2-84.5-88.1v0    c0-49.2,34.3-88.1,84.5-88.1c23.7,0,39.8,7.9,51.1,19.1V72h43.2L925.6,241.6z M836.4,206.4c24,0,45-18.8,45-49.2    c0-30.4-21-49.2-45-49.2c-25.2,0-45.3,18.5-45.3,49.2C791.2,187.8,811.2,206.4,836.4,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.6,53.8c14.3,0,26.4-12.5,26.4-27C734,12.2,721.9,0,707.6,0c-14.3,0-27,11.9-27,26.7    C680.5,41.6,693.3,53.8,707.6,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.6,225.5c0,6.1-0.2,16.4-0.2,16.4h-43.6c0,0,0-24.2,0-34.1V7.5h43.8v81.2c11.2-11.5,27.7-19.5,51.4-19.5    c50.1,0,84.2,38.9,84.2,88.1s-33.7,88.1-84.2,88.1C1020.2,245.6,1003.8,238,992.6,225.5L992.6,225.5z M1038.8,206.7    c25.2,0,45.3-18.8,45.3-49.2s-20.1-49.2-45.3-49.2c-25.2,0-45,18.8-45,49.2S1014.8,206.7,1038.8,206.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.9,0c14.6,0,26.4,12.2,26.4,26.7c0,14.6-11.9,27-26.4,27c-14.6,0-27-12.2-27-27C1137.8,11.9,1150,0,1164.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144,72.3h44.1v141.9c0,5.6,0.1,12.7,3.3,18.5c2.7,4.9,8.6,8,8.6,8v1.1h-47.8c0,0-3.7-2.2-5.8-5.3    c-2.1-3.1-2.4-5.6-2.4-13.3C1144,215.6,1144,72.3,1144,72.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.6,72.3h44.1c0,0,0,176.6,0,187c0,14.2-9.9,21.6-15.9,23.2h-44.9v-1.1c0,0,6.2-2.7,10.1-8.1    c3.9-5.4,6.6-15.1,6.6-29.7V72.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.2694,
    y1: 617.3115,
    x2: 106.7916,
    y2: 388.5344,
    gradientTransform: "matrix(1 0 0 -1 0 614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF98B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#FF3E14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F0182"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.9,241.5H6.2c-4.3,0-7.2-4.2-5.8-8.2L76.6,7.5H147L70.4,233.2C68.9,237.6,71.1,241.5,75.9,241.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152223087808998895760000016394933356120625830_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.9947,
    y1: 500.8661,
    x2: -103.656,
    y2: 355.1504,
    gradientTransform: "matrix(1 0 0 -1 0 614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F0182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#FF3E14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF98B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152223087808998895760000016394933356120625830_)"
    },
    d: "M6.4,241.5c0.8,0,69.3,0,69.3,0    c5.4,0,10.5-2.4,14-6.4L229.7,72.2h-56.2c-4.2,0-8.2,1.7-11.2,4.8L7.7,239.6c-1.5,1.6-2.9,1.5-4.4,1.2    C4.6,241.5,5.5,241.5,6.4,241.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018942162451824552040000003809898237163689129_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8829,
    y1: 556.1931,
    x2: 236.2162,
    y2: 341.5894,
    gradientTransform: "matrix(1 0 0 -1 0 614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF98B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF3E14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#8F0182"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018942162451824552040000003809898237163689129_)"
    },
    d: "M173.2,72.2h68c10.3,0,11.7,9.8,5.9,16.2    c-13.8,15.2-25.5,27.4-38.7,52c-17.1,31.6-18.8,105.5,45.1,96c-12.8,4.2-26.4,5.1-34.7,5.1c-10.2,0-34.9,0-34.9,0    c-2.7,0-12.5-0.9-17.6-2.4c-52.3-16.3-25.1-110.2,8.8-150.6c6.8-8.1,3.9-15.5-1.6-16.2C173.1,72.2,173.5,72.2,173.2,72.2    L173.2,72.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044169378432823948000000002621882930354887058_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.6301,
    y1: 462.6574,
    x2: 231.6301,
    y2: 325.1779,
    gradientTransform: "matrix(1 0 0 -1 0 614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF98B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#FF3E14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#8F0182"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044169378432823948000000002621882930354887058_)"
    },
    d: "M231.9,187.4h65.1    c-5.1,26.2-24.7,54.2-78.9,54.2h-33.7c-5.1,0-14.1-1.2-18-2.4C222.1,237.3,228.7,204.2,231.9,187.4L231.9,187.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKajabi);
export default __webpack_public_path__ + "static/media/kajabi.b82df086c2096965be34cbaa4d226319.svg";
export { ForwardRef as ReactComponent };